import axios, { AxiosRequestConfig } from "axios";
import Config from "../config/Config";
import QueueItemStatusInfo from "../models/viewModels/QueueItemModel";

export type BmpChangeViewModel = {
    bmpGeneralId: number | null;
    bmpName: string;
    rowNumber: number;
    changes: BmpChange[];
}

export type BmpChange = {
    property: string;
    previousValue: string | null;
    newValue: string | null;
}

export class QueueService {
    protected config: AxiosRequestConfig;

    constructor(authToken?: string) {
        this.config = {
            headers: { "Authorization": "Bearer " + authToken },
        }
    }

    async newBulkUpload(jurisdictionId: number, lutQueueTypeId: number, file: File): Promise<void> {
        const formData = new FormData();
        formData.append("excelFile", file);
        formData.append("jurisdictionId", jurisdictionId.toString());
        formData.append("lutQueueTypeId", lutQueueTypeId.toString());

        const configForFiles = { ...this.config };
        configForFiles.headers!["Content-Type"] = "multipart/form-data";
        return await axios
            .post<void>(Config.api_endpoint + `QueueManager`, formData, configForFiles)
            .then(() => {
                return;
            })
            .catch((e) => {
                throw e;
            });
    }

    async getProjectUploadInfo(jurisdictionId: number): Promise<QueueItemStatusInfo[]> {
        return await axios
            .get<QueueItemStatusInfo[]>(Config.api_endpoint + `QueueItem/QueueItemModel/${jurisdictionId}`, this.config)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                throw new Error("Error getting project upload info", e);
            });
    }

    async archiveBulkUpload(queueItemId: number): Promise<void> {
        return await axios
            .delete<void>(Config.api_endpoint + `QueueItem/${queueItemId}`, this.config)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                throw new Error("Error archiving bulk upload" + e.message);
            });
    }

    async getDuplicateQueueItems(queueItemId: number): Promise<BmpChangeViewModel[]> {
        return await axios
            .get<BmpChangeViewModel[]>(Config.api_endpoint + `QueueManager/duplicates/${queueItemId}`, this.config)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                throw new Error("Error getting duplicate queue items" + e.message);
            });
    }

    async approveDuplicateQueueItems(queueItemId: number): Promise<void> {
        return await axios
            .post<void>(Config.api_endpoint + `QueueManager/${queueItemId}/approveDuplicates`, null, this.config)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                throw new Error("Error approving duplicate queue items" + e.message);
            });
    }

    async cancelUpload(queueItemId: number): Promise<void> {
        return await axios
            .post<void>(Config.api_endpoint + `QueueManager/${queueItemId}/cancel`, null, this.config)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                throw new Error("Error canceling upload" + e.message);
            });
    }
}